import "@/App.css";
import { WhatsAppProvider } from "@/components/WhatsAppProvider";
import { SmoothScroll } from "@/components/landing/SmoothScroll";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Services } from "@/components/landing/Services";
import { OfferteMobile, Fibra, LuceGas } from "@/components/sections/Offerte";
import { Telefoni } from "@/components/sections/Telefoni";
import { Business } from "@/components/sections/Business";
import { WhyUs } from "@/components/landing/WhyUs";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Reviews } from "@/components/landing/Reviews";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Contacts } from "@/components/landing/Contacts";
import { Footer } from "@/components/landing/Footer";
import { FloatingButtons } from "@/components/landing/FloatingButtons";

function App() {
  return (
    <div className="App bg-white text-ink antialiased">
      <WhatsAppProvider>
      <SmoothScroll />
      <Header />
      <main>
        <Hero />
        <Services />
        <OfferteMobile />
        <Fibra />
        <LuceGas />
        <Telefoni />
        <Business />
        <WhyUs />
        <HowItWorks />
        <Reviews />
        <FinalCTA />
        <Contacts />
      </main>
      <Footer />
      <FloatingButtons />
      </WhatsAppProvider>
    </div>
  );
}

export default App;
